
import vars from "@exo/narrative-tracker-variables";

import { 
  ENTITY_TYPE_PERSON,
  ENTITY_TYPE_ORG,
  ENTITY_TYPE_VESSEL
} from "../../constants.js";

import {
  mdiAccount as PersonIcon,
  mdiOfficeBuilding as OrgIcon,
  mdiFerry as VesselIcon,
  mdiHelpCircleOutline as UnknownIcon,
 } from '@mdi/js';

 
 export const getNodeIcon = (nodeType) => {
  switch (nodeType) {
    case ENTITY_TYPE_PERSON: return PersonIcon;
    case ENTITY_TYPE_ORG: return OrgIcon;
    case ENTITY_TYPE_VESSEL: return VesselIcon;
    default: return UnknownIcon;
  }
}

export const getNodeImage = (nodeType, darkUI) => {
  switch (nodeType) {
    case ENTITY_TYPE_PERSON: return darkUI ? "/src/static/graphs/person_dark.svg" : "/src/static/graphs/person.svg"; 
    case ENTITY_TYPE_ORG: return darkUI ? "/src/static/graphs/organization_dark.svg" : "/src/static/graphs/organization.svg"; 
    // case ENTITY_TYPE_ORG: return darkUI ? "/src/static/graphs/org_dark.svg" : "/src/static/graphs/org.svg"; 
    case ENTITY_TYPE_VESSEL: return darkUI ? "/src/static/graphs/vessel_dark.svg" : "/src/static/graphs/vessel.svg"; 
    default: return darkUI ? "/src/static/graphs/unknown_dark.svg" : "/src/static/graphs/unknown.svg";
  }
}

export const getNodeColor = (nodeType, isSourceNode, darkUI) => {
  if (isSourceNode) {
    // return darkUI ? "#C94C83" : "#DB4139";
    return darkUI ? "#E0E0E0" : "#404040";
  }
  else {
    switch (nodeType) {
      // case ENTITY_TYPE_VESSEL: return darkUI ? "#579F5F": "#579F5F";
      // case ENTITY_TYPE_ORG: return darkUI ? vars.blue_0_5 : "#5F83CC";
      // case ENTITY_TYPE_PERSON: return darkUI ? "#CF7435" : "#CF7435";
      case ENTITY_TYPE_VESSEL: return darkUI ? "#009E73": "#66C2A5";
      case ENTITY_TYPE_ORG: return darkUI ? "#56B4E9" : "#5F83CC";
      case ENTITY_TYPE_PERSON: return darkUI ? "#E69F00" : "#FE8503";
      default: return "#DB4139";
    }
  }
}

export const getNodeMenuColor = (nodeType, isSourceNode, darkUI) => {
  const opacity = 0.8;
  if (isSourceNode) {
    return darkUI ? `rgba(224, 224, 224, ${opacity})` : `rgba(64, 64, 64, ${opacity})`;
  }
  else {
    switch (nodeType) {
      case ENTITY_TYPE_VESSEL: return darkUI ? `rgba(0, 158, 115, ${opacity})`: `rgba(102, 194, 165, ${opacity})`;
      case ENTITY_TYPE_ORG: return darkUI ? `rgba(86, 180, 233, ${opacity})` : `rgba(95, 131, 204, 0${opacity})`;
      case ENTITY_TYPE_PERSON: return darkUI ? `rgba(230, 159, 0, ${opacity})` : `rgba(254, 133, 3, ${opacity})`;
      default: return `rgba(219, 65, 57, ${opacity})`;
    }
  }
}

export const getEdgeColor = (edgeType, darkUI) => {
  return darkUI ? vars.charcoal_0_5 : vars.grey_1;
}